import { Component, output, ChangeDetectionStrategy } from "@angular/core";
import { S25IconComponent } from "../s25-icon/s25.icon.component";

@Component({
    selector: "modal-close-button",
    template: `
        <a
            href="javascript:void(0);"
            class="s25modal-close s25modal-close-pos"
            (click)="close.emit()"
            aria-label="Close"
        >
            <s25-ng-icon [type]="'close'" [ariaLabel]="false" />
        </a>
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [S25IconComponent],
})
export class ModalCloseButtonComponent {
    readonly close = output<void>();
}
